const FABRIC_BASE_COLORS:Record<string, string> = {
    'cotton-silk': '#E4E6D8',
    'matte-crepe': '#F9FAF5',
    'silk-habotai': '#F0F0E6',
    polychiffon: '#F0F0E6',
    'satin-charmeuse': '#F0F0E6',
    'silk-charmeuse': '#F0F0E6',
}

export const getFabricBaseColor = (fabric:string):string => (
    FABRIC_BASE_COLORS[fabric] ?? '#ffffff'
)
